import { defineStore } from 'pinia'

const defaultState = {
  collection_page_id: null,
  page_url: null,
  title: null,
  meta_title: null,
  meta_description: null,
  robots: null,
  conditions: null,
  show_in_navigation: false,
  navigation_sort_order: null,
  desktop_asset_id: null,
  tablet_asset_id: null,
  mobile_asset_id: null
}

export const useCollectionPageStore = defineStore('collectionPage', {
  state: () => ({
    entity: { ...defaultState }
  }),
  getters: {
    page: ({ entity }) => entity
  },
  actions: {
    async fetchCollectionPage(collectionPageId) {
      const { ApiController } = await _getModules()
      this.entity = { ...defaultState }
      try {
        this.entity = await ApiController.fetchCollectionPage(collectionPageId)
      } catch (error) {
        console.error('Failed to fetch collection page:', error)
        const url = this.router.resolve(this.router.currentRoute.value).fullPath
        this.router.push(`/error?original=${url}`)
      }
    }
  }
})

const _getModules = (() => {
  let cache

  return async () => {
    if (cache) return cache

    const { default: ApiController } = await import('@/services/ApiController')
    cache = { ApiController }
    return cache
  }
})()
